import { ListOfDocs } from '../utils/google'
import { useState } from 'react';
import {Typography } from '@mui/material';

export function Documents() {
    const [iframeRef, setiframe] = useState(null);

    return (
      <div style={{ display: 'flex', justifyContent: 'center', height:"100%", width:'100%'}}>
        <div style={{display:'inline', width:"80%", height:"100%"}}>
            {iframeRef ? 
                <iframe src={`https://docs.google.com/document/d/${iframeRef}/edit?embedded=true`} title="Google Docs Iframe" width="100%" height="100%" sandbox="allow-scripts allow-same-origin allow-forms"/>:
                <div style={{width:"100%", height:"100%", backgroundColor:'rgba(0,0,0,0.2)', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <div style={{backgroundColor:'white', border:'1px solid green', borderRadius:'20px', height:'150px', width:'500px', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <h2 style={{display:'block', height:'30px', fontSize:'20px', fontWeight: '340'}}>Выберите документ для начала работы</h2>
                    </div>
                </div>
            }
        </div>
        <div style={{display:'inline', width:"20%", height:"100%"}}>
            <ListOfDocs
                setiframe={setiframe}
            />
        </div>
        </div>
    );
  }